import { metricsService } from "./metricsService";
import { faker } from "@faker-js/faker";

export const userActivityData = async () => {
  // Get a list of users with first_session metrics
  const result = await metricsService.getMetricList({
    names: ["first_session"],
  });

  const totalActivityTimeSpentByUsername = await metricsService.getTotalActivityTimeSpentByUsername()
  const mostRecentActivityByUsername = await metricsService.getMostRecentActivityByUsername()

  const roster = {};
  result.forEach((metric) => {
    const username = metric.tags.find((tag) => tag.startsWith("username:"));
    if (username) {
      if (
        !roster[username] ||
        roster[username].firstActive > new Date(metric.created_at)
      ) {
        roster[username] = { firstActive: new Date(metric.created_at) };
      }
    }
  });

  const userPromises = Object.keys(roster).map(async (username) => {
    if (!!totalActivityTimeSpentByUsername[username] & !!mostRecentActivityByUsername[username]) {
      roster[username].userEmail = username.split(":")[1]
      roster[username].fullName = mostRecentActivityByUsername[username].metadata?.find(
        (md) => md.key === "fullName"
      )?.value;
      roster[username].lastActive = new Date(mostRecentActivityByUsername[username].created_at);
      roster[username].lastRoles =
      mostRecentActivityByUsername[username].metadata
          ?.find((md) => md.key === "roles")
          ?.value.split(",") || [];
      roster[username].recents = JSON.parse(
        mostRecentActivityByUsername[username].metadata?.find((md) => md.key === "recentRoutes")?.value ||
          "[]"
      );
      roster[username].timeSpent = totalActivityTimeSpentByUsername[username] || 0;
    }
    return {
      userName: roster[username].fullName || roster[username].userEmail,
      firstActive: roster[username].firstActive,
      lastActive: roster[username].lastActive || null,
      timeSpent: roster[username].timeSpent || 0,
      lastRoles: roster[username].lastRoles || [],
      recents: roster[username].recents || [],
      userEmail: roster[username].userEmail,
    };
  });

  // Wait for all promises to resolve
  let data = await Promise.all(userPromises);

  // Check if ?mock=true is in the current URL
  if (window.location.search.includes("mock=true")) {
    const mockUsers = generateMockUsers(200 - data.length);
    data = [...data, ...mockUsers];
  }
  // Sort on last active date
  const sortedData = data.sort((a, b) => {
    if (!a.lastActive) return 1;
    if (!b.lastActive) return -1;
    return b.lastActive - a.lastActive;
  });
  return sortedData;
};

function generateMockUsers(count) {
  const mockUsers = [];
  const roles = [
    "admin",
    "prompt-engineer",
    "clinical-author",
    "demonstrator",
    "viewer",
    "champion",
  ];
  const recentRoutes = [
    "/dashboard",
    "/profile",
    "/settings",
    "/analytics",
    "/reports",
  ];

  for (let i = 0; i < count; i++) {
    const now = new Date();
    // const firstActive = faker.date.past(3); // Random date in the last 3 years
    // const lastActive = faker.date.between({ from: firstActive, to: now });
    const firstActive = new Date(now - Math.random() * 90 * 24 * 60 * 60 * 1000); // Random date within last 90 days
    const lastActive = new Date(Math.max(firstActive.getTime(), now - Math.random() * 7 * 24 * 60 * 60 * 1000)); // Random date between firstActive and now, up to 7 days ago

    mockUsers.push({
      userName: faker.person.fullName(),
      firstActive: firstActive,
      lastActive: lastActive,
      timeSpent: faker.number.int({ min: 60, max: 100000 }), // Random time between 1 minute and ~27 hours
      lastRoles: faker.helpers.arrayElements(roles, { min: 1, max: 3 }), // 1 to 3 random roles
      recents: faker.helpers.arrayElements(recentRoutes, { min: 0, max: 5 }), // 0 to 5 random recent routes
    });
  }

  return mockUsers;
}
